var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-menu"},[_c('div',{staticClass:"account-menu__form-title"},[_vm._v("\n        Notifications\n    ")]),_vm._v(" "),_c('ul',_vm._l((_vm.items),function(item,key){return _c('div',{key:key},[_vm._v("\n            "+_vm._s(item.subject)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }